import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Form, Button } from 'reactstrap';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import * as actions from 'store/modules/links';

import { reloadIframe } from 'helpers/reloadIframe';

import CreatedLink from 'components/CreatedLink';

import listDropImg from 'images/list-drop-img.svg';

class CreatedAllLinks extends Component {
  state = {
    linkEdit: null,
  };
  componentDidMount() {
    const { linksListAction, match } = this.props;
    const id = match.params.id;
    linksListAction(id);
  }

  handleDelete = async id => {
    const { match } = this.props;
    this.onEditCancel();
    const { removeLinkAction } = this.props;
    const accId = match.params.id;
    const response = await removeLinkAction(accId, id);
    if (response.status === 'success') {
      reloadIframe();
    }
  };

  handleApprove = async (values, id) => {
    const { updateLinkAction, match } = this.props;
    let param = {
      id,
      body: {
        link: {
          name: values.name,
          url: values.url,
          image: values.image,
        },
      },
    };
    const accId = match.params.id;
    const response = await updateLinkAction(accId, param);
    if (response.status === 'success') {
      reloadIframe();
    }
    this.onEditCancel();
  };

  handleEdit = id => {
    this.setState({ linkEdit: id });
  };

  onEditCancel = () => {
    this.setState({ linkEdit: null });
  };

  onDragEnd = async result => {
    if (!result.destination) {
      return;
    }
    const { moveLinkAction, match } = this.props;
    let param = {
      id: result.draggableId,
      startIndex: result.source.index,
      endIndex: result.destination.index,
      body: {
        position: result.destination.index + 1,
      },
    };
    const accId = match.params.id;

    const response = await moveLinkAction(accId, param);
    if (response.status === 'success') {
      reloadIframe();
    }
  };

  renderDnDItem = (link, index) => (
    <Draggable key={link.id} draggableId={link.id} index={index}>
      {provided => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <CreatedLink
            link={link}
            account={this.props.account}
            mode={this.state.linkEdit === link.id ? 'edit' : 'display'}
            onDelete={this.handleDelete}
            onEdit={this.handleEdit}
            onApprove={this.handleApprove}
            onEditCancel={this.onEditCancel}
            dragbleImage={() => {
              return (
                <div className="link-itm__dnd" {...provided.dragHandleProps}>
                  <img src={listDropImg} alt="" />
                </div>
              );
            }}
          />
        </div>
      )}
    </Draggable>
  );

  render() {
    const { linksList, handleShow, showForm } = this.props;
    return (
      <Fragment>
        <div className="my-links-top">
          <h2 className="h2-title">My links</h2>
          {!showForm && (
            <Button onClick={handleShow} color="blue" className="dtn btn-blue">
              Create new link
            </Button>
          )}
        </div>
        <div className="separator-line" />
        {linksList.length === 0 && (
          <div className="my-links-top__missing">
            You don’t have any links yet
          </div>
        )}
        <Form className="content-form m-b-50 m-r-0">
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="droppable">
              {provided => (
                <div ref={provided.innerRef}>
                  {linksList.map(this.renderDnDItem)}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Form>
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    linksList: state.links.linksList,
    token: state.auth.token,
    account: state.content.account,
  };
}
export default connect(
  mapStateProps,
  actions,
)(withRouter(CreatedAllLinks));



// WEBPACK FOOTER //
// ./src/components/CreatedAllLinks/CreatedAllLinks.js